<template>
  <div class="page-wrapper">
    <div class="youtube-wrapper" ref="dragObject">
      <div class="drag-toggle">
      <button
        class="btn-close"
        @click="$emit('close')"
      >
        <img src="../assets/baseline-close-24px.svg" alt="close">
      </button>
      </div>
      <div class="youtube-inner">
        <iframe :src="url" frameborder="0" allow="accelerometer; autoplay; gyroscope;" allowfullscreen></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      positions: [0, 0, 0, 0]
    }
  },
  mounted () {
    this.dragElement(this.$refs.dragObject)
  },
  methods: {
    dragElement (elmnt) {
      var pos1 = 0
      var pos2 = 0
      var pos3 = 0
      var pos4 = 0
      elmnt.onmousedown = dragMouseDown

      function dragMouseDown (e) {
        e = e || window.event
        e.preventDefault()
        // get the mouse cursor position at startup:
        pos3 = e.clientX
        pos4 = e.clientY
        document.onmouseup = closeDragElement
        // call a function whenever the cursor moves:
        document.onmousemove = elementDrag
      }
      function elementDrag (e) {
        e = e || window.event
        e.preventDefault()
        // calculate the new cursor position:
        pos1 = pos3 - e.clientX
        pos2 = pos4 - e.clientY
        pos3 = e.clientX
        pos4 = e.clientY
        // set the element's new position:
        elmnt.style.top = (elmnt.offsetTop - pos2) + 'px'
        elmnt.style.left = (elmnt.offsetLeft - pos1) + 'px'
      }
      function closeDragElement () {
      // stop moving when mouse button is released:
        document.onmouseup = null
        document.onmousemove = null
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.page-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  transition: background cubic-bezier(0.95, 0.05, 0.795, 0.035) .3s;
  background: rgba($color: #35bae5, $alpha: 0);

  .youtube-wrapper {
    position: absolute;
    box-shadow: -1px 1px 9px 7px rgba($color: black, $alpha: .25);
    max-width: 560px;
    width: 95%;

    .youtube-inner {
      max-width: 560px;
      width: 100%;
      height: 315px;
      background: black;

      iframe {
        cursor: pointer;
        width: 100%;
        height: 100%;
      }
    }

    .drag-toggle {
      position: relative;
      background: black;
      color: white;
      font-size: 2rem;
      font-weight: bolder;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      text-transform: uppercase;
      cursor: move;
      border-radius: 6px 6px 0 0;
      padding: .5rem;
    }

    .btn-close {
      cursor: pointer;
      background: black;
      border-radius: 6px;
      border: none;
    }
  }
}
</style>
